import { z } from "zod";

/**
 * This is the source of truth for the models that we support.
 *
 * If you add a new model, you will need to:
 * 1) Update any dependant code (all of this should be type-checked based on InferenceModelType).
 * 2) Update the website models content, if necessary, using the tooling in @kuzco/website-scripts (ask Sean if you need help).
 */
export const INFERENCE_MODELS = [
  "meta-llama/llama-3.1-8b/fp-8",
  "meta-llama/llama-3.1-70b/fp-8",
  "meta-llama/llama-3.1-8b-instruct/q4-k-m",
  "meta-llama/llama-3.1-8b-instruct/fp-8",
  "meta-llama/llama-3.1-8b-instruct/fp-16",
  "meta-llama/llama-3.1-70b-instruct/fp-8",
  "meta-llama/llama-3.1-70b-instruct/fp-16",
  "meta-llama/llama-3.3-70b-instruct/fp-8",
  "meta-llama/llama-3.3-70b-instruct/fp-16",
  "meta-llama/llama-3.2-1b-instruct/fp-8",
  "meta-llama/llama-3.2-1b-instruct/fp-16",
  "meta-llama/llama-3.2-3b-instruct/fp-8",
  "meta-llama/llama-3.2-3b-instruct/fp-16",
  "meta-llama/llama-3.2-11b-instruct/fp-16",
  "mistralai/mistral-nemo-12b-instruct/fp-8",
  "RLAIF/sft-llama-3.1-8b-external/fp-16",

  "deepseek/deepseek-v3/fp-8",
  "deepseek/deepseek-v3-0324/fp-8",

  "deepseek/deepseek-r1/fp-8",
  "deepseek/deepseek-r1-0528/fp-8",

  "deepseek/r1-distill-llama-70b/fp-8",

  "google/gemma-3-27b-instruct/bf-16",

  "qwen/qwen3-30b-a3b/fp8",
  "tenacity-labs/magneta-chat-v3",

  "qwen/qwen2.5-72b-instruct/fp-8",

  "qwen/qwq-32b/fp-8",

  "qwen/qwen2.5-7b-instruct/bf-16",

  "nous/hermes-3-llama-3.1-405b/fp-8",
  "thedrummer/unslopnemo-12b-v4.1/bf-16",
  "thedrummer/rocinante-12b-v1.1/bf-16",
  "gryphe/mythomax-l2-13b/bf-16",

  "deepseek/deepseek-vl2-tiny/fp-16",
  "deepseek/deepseek-vl2-small/fp-16",

  "osmosis-ai/osmosis-structure-0.6b/fp-32",

  "qwen/qwen3-embedding-4b",

  "inference-net/cliptagger-12b",
  "wynd/wynd-vidcap-12b", // deprecated

  "cal-ai/food-vision-12b",
  "cal-ai/food-vision-27b",
  "cal-ai/food-vision-v3",
  "cal-ai/food-vision-v4",
  "cal-ai/food-vision-v5",

  "olive/analyze-product-v1",

  "openai/gpt-oss-120b",
  "openai/gpt-oss-20b",

  "inference-net/schematron-3b",
  "inference-net/schematron-8b",
  "inference-net/schematron-v3",
  "inference-net/schematron-v2-small",
  "inference-net/schematron-v2-turbo",

  "inference-net/bdc-coder-qwen3-14b",
  "inference-net/bdc-coder",

  "profound-ai/profound-entity-recognition",

  "inference-net/load-test",

  "tenacity-labs/magneta-chat",

  "gravity/gravity-xs",
  "gravity/gravity-s",
  "gravity/gravity-v2",

  "rizz/rizz-chat",

  "nvidia/nemotron3-super",

  "deepseek/deepseek-v4-flash",
] as const;

export const InferenceModelSchema = z.string();

export type InferenceModelType = string;

export const INSTANCE_RUNTIME = ["vllm", "sglang", "trt"] as const;

export type InstanceRuntimeType = (typeof INSTANCE_RUNTIME)[number];
